import { Box, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import type { BarcodePreviewPosition } from './model'

type Props = {
  positions: BarcodePreviewPosition[]
}

// バーコードの位置（1,2,3,...）を表示するコンポーネント
export const BarcodePreviewPositionLabels: FC<Props> = ({ positions }) => {
  return (
    <Stack direction="row" sx={{ mt: 1 }}>
      {positions.map(position => (
        <Box key={position.value} sx={{ flex: 1, textAlign: 'center' }}>
          <Typography
            sx={{
              color: position.inRange ? 'primary.main' : 'text.disabled',
              fontFamily: 'monospace',
              fontSize: 28,
              fontWeight: position.inRange ? 'bold' : 'normal',
              lineHeight: 1,
            }}
          >
            {position.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}
